<template>
<div class="chapter">
<div class="inner_page">
<p class="C143"><a id="page_xxx"></a>T<span class="small">HE</span> M<span class="small">ARQUIS OF</span> L<span class="small">OSSIE</span></p>
<p class="C162">1877</p>
<p class="C163">The Cullen Collection</p>
<p class="C164">Volume 20</p>
<p class="C108"><img alt="" height="auto" src="Images/image00223.jpeg" width="61%"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part0010.vue?44df2d66